import "./GraphsEvaluations.css";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import DashboardFilters from "../DashboardFilters/DashboardFilters";
import Logo from '../../webAppAssets/3D-icon.svg';

import { Chart as ChartJS, CategoryScale, BarElement, LinearScale, PointElement, LineElement, Tooltip, LineController, BarController} from "chart.js";
import { Chart } from "react-chartjs-2";


ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, LineController, BarController);

const GraphsEvaluations = ({data, filters, handle, type, selectedEvaluations }) => {
    const { t } = useTranslation(["charts-evaluations"]);

    const [graph1, setGraph1] = useState(null);
    const [graph2, setGraph2] = useState(null);
    const [graph3, setGraph3] = useState(null);
    const [graph4, setGraph4] = useState(null);

    useEffect(() => {
        setGraph1({
            labels: data.labels,
            datasets: [
                {
                    type: 'bar',
                    label: t("10 meters sprint"),
                    backgroundColor: '#091DC9', 
                    borderWidth: false,
                    borderRadius: 10,
                    data: data.graph1.bar1,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("20 meters sprint"),
                    backgroundColor: '#0B24FB', 
                    data: data.graph1.bar2,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("30 meters sprint"),
                    backgroundColor: '#3C50FC',
                    data: data.graph1.bar3,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },{
                    type: 'bar',
                    label: t("Agility"),
                    backgroundColor: 'rgb(105, 120, 249)', 
                    data: data.graph1.bar4,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
            ],
        });

        setGraph2({
            labels: data.labels,
            datasets: [
                {
                    type: 'line',
                    label: t("BMI"),
                    borderColor: 'rgb(252,165,85, 0)',
                    backgroundColor: 'rgb(4, 14, 100)',
                    borderWidth: 5,
                    pointRadius: 6,
                    data: data.graph2.line,
                    yAxisID: 'y1',
                },
                {
                    type: 'bar',
                    label: t("Height in cm"),
                    backgroundColor: 'rgb(105, 120, 249)',
                    data: data.graph2.bar1,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("Weight in kg"),
                    backgroundColor: 'rgb(252, 165, 85)',
                    data: data.graph2.bar2,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
            ],
        });

        setGraph3({
            labels: data.labels,
            datasets: [
                {
                    type: 'line',
                    label: t("Aerobic Capacity"),
                    borderColor: 'rgb(252,165,85, 0)',
                    backgroundColor: 'rgb(4, 14, 100)',
                    borderWidth: 5,
                    pointRadius: 6,
                    data: data.graph3.line,
                    yAxisID: 'y1',
                },
                {
                    type: 'bar',
                    label: t("SJ"),
                    backgroundColor: 'rgb(105, 120, 249)',
                    data: data.graph3.bar1,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("CMJ"),
                    backgroundColor: 'rgb(252,165,85)',
                    data: data.graph3.bar2,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("HJ"),
                    backgroundColor: 'rgb(252,165,85)',
                    data: data.graph3.bar3,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                }
            ],
        });

        setGraph4({
            labels: data.labels,
            datasets: [
                {
                    type: 'line',
                    label: t("Average Anaerobic"),
                    borderColor: 'rgb(252,165,85, 0)',
                    backgroundColor: 'rgb(4, 14, 100)',
                    borderWidth: 5,
                    pointRadius: 6,
                    data: data.graph4.line,
                    yAxisID: 'y1',
                },
                {
                    type: 'bar',
                    label: t("Worst Anaerobic"),
                    backgroundColor: 'rgb(105, 120, 249)',
                    data: data.graph4.bar1,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
                {
                    type: 'bar',
                    label: t("Best Anaerobic"),
                    backgroundColor: 'rgb(252, 165, 85)',
                    data: data.graph4.bar2,
                    borderWidth: false,
                    borderRadius: 10,
                    yAxisID: 'y',
                },
            ],
        });
        
    }, [data]);

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
            display: false,
            },
            title: {
            display: false,
            },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };

    const options1 = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
            display: false,
            },
            title: {
            display: false,
            },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
            }
        }
    };

    return (
        <div className="webapp-graphuc">
            <div className="webapp-graphuc-filters">
                {filters?.map((filter, index) => {
                    if (index === 2) {
                        return(
                            <DashboardFilters name={filter.name} filters={filter.content} handle={handle} type={type[index]} selectedFilters={selectedEvaluations}/>
                        )
                    } else {
                        return(
                            <DashboardFilters name={filter.name} filters={filter.content} handle={handle} type={type[index]}/>
                        )
                    }
                })}
            </div>
            {graph1 && <div className="webapp-graphuc-content">
                <div className="webapp-graphuc-header">
                    <h2 className="webapp-graphuc-header-title">{t("Speed Tests")}</h2>
                </div>
                <div className="webapp-graphuc-chart">
                    <Chart data={graph1} options={options1}/>
                </div>
            </div>}
            {graph2 &&<div className="webapp-graphuc-content">
                <div className="webapp-graphuc-header">
                    <h2 className="webapp-graphuc-header-title">{t("Measurements")}</h2>
                </div>
                <div className="webapp-graphuc-chart">
                    <Chart data={graph2} options={options}/>
                </div>
            </div>}
            {graph3 && <div className="webapp-graphuc-content">
                <div className="webapp-graphuc-header">
                    <h2 className="webapp-graphuc-header-title">{t("Leg Power (SJ - CMJ - HJ) and Aerobic IR1")}</h2>
                </div>
                <div className="webapp-graphuc-chart">
                    <Chart data={graph3} options={options}/>
                </div>
            </div>}
            {graph4 && <div className="webapp-graphuc-content">
                <div className="webapp-graphuc-header">
                    <h2 className="webapp-graphuc-header-title">{t("Anaerobic Capacity")}</h2>
                </div>
                <div className="webapp-graphuc-chart">
                    <Chart data={graph4} options={options}/>
                </div>
            </div>}
            {graph4 && window.innerWidth >= 1500 && <div className="webapp-graphuc-content" id="logo-graph">
                <img className="webapp-graph-logo" src={Logo} />
            </div>}
        </div>
    );
}

export default GraphsEvaluations;